import {
  COMMERCE_EVENTS,
  type CommerceEventName,
  type CommerceEventProps,
} from '@rehub/pricing';

export type CommerceTracker = (event: CommerceEventName, props?: CommerceEventProps) => void;

function defaultEmit(event: CommerceEventName, props?: CommerceEventProps): void {
  const gtag = typeof window !== 'undefined' ? (window as unknown as { gtag?: (...args: unknown[]) => void }).gtag : undefined;
  gtag?.('event', event, props || {});
}

export function createCommerceTracker(
  emit?: CommerceTracker
): CommerceTracker {
  return (event, props) => {
    if (!COMMERCE_EVENTS.includes(event)) return;
    try {
      (emit || defaultEmit)(event, props);
    } catch {
      /* analytics must never break checkout */
    }
  };
}

export { COMMERCE_EVENTS };
export type { CommerceEventName, CommerceEventProps };
